import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const adminContractorsApi = createApi({
  reducerPath: "admin-contractors",
  tagTypes: ['Contractors'],
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({

   getAllContractors: builder.query({
    query: ({
      pageno,
      search,
      status,
      sortOrder,
      sortBy,
      disablePagination,
      limit
    }) => {
      const params = new URLSearchParams();

      if (pageno !== undefined) params.append("pageno", pageno);
      if (search) params.append("search", search);
      if (status) params.append("status", status);
      if (sortOrder) params.append("sortOrder", sortOrder);
      if (sortBy) params.append("sortBy", sortBy);
      if (disablePagination !== undefined) {
        params.append("disablePagination", disablePagination);
      }
      if(limit) params.append("limit" ,limit)
      return {
        url: `admin/contractors?${params.toString()}`,
        method: "GET",
      };
    },
    providesTags: ["Contractors"],
  }),

    updateContractorStatus: builder.mutation({
      query: (id) => ({
        url: `admin/contractor/status/${id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
      invalidatesTags: (result, error) => error ? [] : ['Contractors'], // ✅
    }),

    getContractorById: builder.query({
      query: (id) => `admin/contractor/${id}`,
      transformResponse: (res) => res?.body,
      providesTags: ['Contractors'],
    }),

    addNewContractor: builder.mutation({
      query: (newContractor) => ({
        url: `admin/contractor`,
        method: "POST",
        body: newContractor,
      }),
      invalidatesTags: (result, error) => error ? [] : ['Contractors'], // ✅
    }),

    updateContractor: builder.mutation({
      query: ({ id, data }) => ({
        url: `admin/contractor/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error) => error ? [] : ['Contractors'], // ✅
    }),

    getContractorJobs: builder.query({
      query: ({ id, pageno }) => `admin/contractor/jobs/${id}?pageno=${pageno}`,
      providesTags: ['Contractors'],
    }),

    getContractorClients: builder.query({
      query: ({ id, pageno }) => `admin/contractor/clients/${id}?pageno=${pageno}`,
      providesTags: ['Contractors'],
    }),

    getContractorInventory: builder.query({
      query: ({ id, pageno }) => `admin/contractor/inventory/${id}?pageno=${pageno}`,
      providesTags: ['Contractors'],
    }),

    getContractorTechnicians: builder.query({
      query: ({ id, pageno }) => `admin/contractor/technicians/${id}?pageno=${pageno}`,
      providesTags: ['Contractors'],
    }),

    deleteContractor: builder.mutation({
      query: (id) => ({
        url: `admin/contractor/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error) => error ? [] : ['Contractors'], // ✅
    }),
    getContractorEstimatorTemplates: builder.query({
      query: ({ id, pageno }) => `admin/contractor/estimator_templates/${id}?pageno=${pageno}`,
      providesTags: ['Contractors'],
    }),

  }),
});

export const {
  useGetAllContractorsQuery,
  useGetContractorByIdQuery,
  useAddNewContractorMutation,
  useUpdateContractorMutation,
  useUpdateContractorStatusMutation,
  useGetContractorJobsQuery,
  useGetContractorClientsQuery,
  useGetContractorInventoryQuery,
  useGetContractorTechniciansQuery,
  useGetContractorEstimatorTemplatesQuery,
  useDeleteContractorMutation
} = adminContractorsApi;